if (!customElements.get('contact-calendar')) {
  customElements.define(
    'contact-calendar',
    class ContactCalendar extends HTMLElement {
      constructor() {
        super();
        const now = new Date();
        this.currentYear = now.getFullYear();
        this.currentMonth = now.getMonth();
        this._toastTimer = null;
      }

      connectedCallback() {
        this._monthTitle = this.querySelector('.contact-cta__cal-month-title');
        this._grid = this.querySelector('.contact-cta__calendar-grid');
        this._toast = this.querySelector('.contact-cta__calendar-toast');
        this._prevBtn = this.querySelector('.contact-cta__cal-prev');
        this._nextBtn = this.querySelector('.contact-cta__cal-next');

        this._prevBtn.addEventListener('click', () => this._navigate(-1));
        this._nextBtn.addEventListener('click', () => this._navigate(1));
        this._grid.addEventListener('click', (e) => this._handleDateClick(e));

        this._render();
      }

      disconnectedCallback() {
        if (this._toastTimer) clearTimeout(this._toastTimer);
      }

      _navigate(direction) {
        this.currentMonth += direction;
        if (this.currentMonth > 11) {
          this.currentMonth = 0;
          this.currentYear++;
        } else if (this.currentMonth < 0) {
          this.currentMonth = 11;
          this.currentYear--;
        }
        this._render();
      }

      _isAvailable(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const day = date.getDay(); // 0 = Sun, 6 = Sat
        return day !== 0 && day !== 6 && date >= today;
      }

      _render() {
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];

        this._monthTitle.textContent = `${monthNames[this.currentMonth]} ${this.currentYear}`;

        const firstDay = new Date(this.currentYear, this.currentMonth, 1);
        const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

        // Convert to Monday-based week index (Mon = 0 … Sun = 6)
        const rawDay = firstDay.getDay(); // 0=Sun, 1=Mon…
        const startOffset = (rawDay + 6) % 7;

        const totalCells = Math.ceil((startOffset + daysInMonth) / 7) * 7;
        const prevMonthLastDay = new Date(this.currentYear, this.currentMonth, 0).getDate();

        let html = '';

        for (let i = 0; i < totalCells; i++) {
          const dayNum = i - startOffset + 1;

          if (dayNum < 1) {
            const overflowDate = prevMonthLastDay + dayNum;
            html += `<div class="contact-cta__cal-day contact-cta__cal-day--overflow" aria-hidden="true">${overflowDate}</div>`;
          } else if (dayNum > daysInMonth) {
            const overflowDate = dayNum - daysInMonth;
            html += `<div class="contact-cta__cal-day contact-cta__cal-day--overflow" aria-hidden="true">${overflowDate}</div>`;
          } else {
            const date = new Date(this.currentYear, this.currentMonth, dayNum);
            const available = this._isAvailable(date);
            const stateClass = available
              ? 'contact-cta__cal-day--available'
              : 'contact-cta__cal-day--unavailable';
            const isoDate = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
            const ariaLabel = `${dayNum} ${monthNames[this.currentMonth]} ${this.currentYear}${available ? '' : ', not available'}`;

            html += `<button
              class="contact-cta__cal-day ${stateClass}"
              data-date="${isoDate}"
              aria-label="${ariaLabel}"
            >${dayNum}</button>`;
          }
        }

        this._grid.innerHTML = html;
      }

      _handleDateClick(e) {
        const dayEl = e.target.closest('.contact-cta__cal-day');
        if (!dayEl) return;

        if (dayEl.classList.contains('contact-cta__cal-day--unavailable')) {
          this._showToast('This date is not available. Please select another date.');
        } else if (dayEl.classList.contains('contact-cta__cal-day--available')) {
          this._grid.querySelectorAll('.contact-cta__cal-day--selected').forEach((el) => {
            el.classList.remove('contact-cta__cal-day--selected');
          });
          dayEl.classList.add('contact-cta__cal-day--selected');
        }
      }

      _showToast(message) {
        if (this._toastTimer) clearTimeout(this._toastTimer);
        this._toast.textContent = message;
        this._toast.hidden = false;
        this._toastTimer = setTimeout(() => {
          this._toast.hidden = true;
        }, 3000);
      }
    }
  );
}
